import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="relative bg-gradient-to-br from-navy-950 via-blue-950 to-navy-950 text-white overflow-hidden" data-id="element-240">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-241">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-blue-500 rounded-full opacity-10 blur-3xl" data-id="element-242"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-400 rounded-full opacity-10 blur-3xl" data-id="element-243"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-244">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12" data-id="element-245">
          {/* Company Info */}
          <div className="col-span-1" data-id="element-246">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jq92PGrktbCMyEbrUBGpE9/SS-Logomark_Ether.webp" alt="SmartSoda Logo" className="h-16 mb-6" width="64" height="64" loading="lazy" decoding="async" data-id="element-247" />
            <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-248">
              Premium beverage solutions that elevate experiences, enhance
              wellness, and promote sustainability.
            </p>
          </div>
          {/* Solutions */}
          <div className="col-span-1" data-id="element-249">
            <h3 className="text-lg font-semibold mb-6 text-blue-300" data-id="element-250">
              Solutions
            </h3>
            <ul className="space-y-4" data-id="element-251">
              <li data-id="element-252">
                <a href="https://breakrooms.smartsoda.com" className="text-gray-300 hover:text-blue-400 transition-colors duration-200 flex items-center group" data-id="element-253">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200" data-id="element-254"></span>
                  Office Breakrooms
                </a>
              </li>
              <li data-id="element-255">
                <a href="https://restaurant.smartsoda.com" className="text-gray-300 hover:text-blue-400 transition-colors duration-200 flex items-center group" data-id="element-256">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200" data-id="element-257"></span>
                  Restaurants & Cafes
                </a>
              </li>
              <li data-id="element-258">
                <a href="https://spa.smartsoda.com" className="text-gray-300 hover:text-blue-400 transition-colors duration-200 flex items-center group" data-id="element-259">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200" data-id="element-260"></span>
                  Spas & Wellness Centers
                </a>
              </li>
              <li data-id="element-261">
                <a href="https://showroom.smartsoda.com" className="text-gray-300 hover:text-blue-400 transition-colors duration-200 flex items-center group" data-id="element-262">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200" data-id="element-263"></span>
                  Showrooms & Events
                </a>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div className="col-span-1" data-id="element-264">
            <h3 className="text-lg font-semibold mb-6 text-blue-300" data-id="element-265">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-266">
              <li className="flex items-start" data-id="element-267">
                <MailIcon className="h-5 w-5 text-blue-400 mt-1 mr-3 flex-shrink-0" data-id="element-268" />
                <a href="mailto:office@smartsoda.com" className="text-gray-300 hover:text-blue-400 transition-colors duration-200" data-id="element-269">
                  office@smartsoda.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-270">
                <PhoneIcon className="h-5 w-5 text-blue-400 mt-1 mr-3 flex-shrink-0" data-id="element-271" />
                <span className="text-gray-300" data-id="element-272">
                  Available 24/7 for support
                </span>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10" data-id="element-273">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-274">
            <div className="text-center md:text-left" data-id="element-275">
              <p className="text-gray-400 text-sm" data-id="element-276">
                &copy; {new Date().getFullYear()} SmartSoda, Inc. All rights
                reserved.
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-277">
                Committed to creating delicious beverages with sustainable
                practices.
              </p>
            </div>
            <div className="flex space-x-6 text-sm" data-id="element-278">
              <a href="/privacy" className="text-gray-400 hover:text-blue-400 transition-colors duration-200" data-id="element-279">
                Privacy Policy
              </a>
              <a href="/terms" className="text-gray-400 hover:text-blue-400 transition-colors duration-200" data-id="element-280">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;